export * from "./text-input-icon";